import { useEffect, useState, SetStateAction, Dispatch } from "react";
import { ModalCore } from "src/Pages/components";

import { ModalCommissionProgress } from "../../../../../components/CommissionGradeProgress/ModalCommissionProgress";

import { UseGetComissaoCorretora } from "./Hooks/UseGetComissaoCorretora";

interface IModalViewRecibos {
  setOpen: Dispatch<SetStateAction<boolean>>;
  open: boolean;

  setId: Dispatch<SetStateAction<string>>;
  id: string;
}

export interface IValueComissaoModal {
  date_vigencia: string;
  vitalicio: string | null;
  name: string;
  operadora_name: string;
  operadora_code: string;

  modalidade_name: string;
  modalidade_code: string;

  administradora_name: string | null;
  administradora_code: string | null;
  parcelas: {
    parc: number;
    value: number;
  }[];
}

export const ModalViewComissãoCorretora = ({
  id,
  open,
  setId,
  setOpen,
}: IModalViewRecibos) => {
  const { loading, handleGet } = UseGetComissaoCorretora();

  const [dataCommission, setDataCommission] = useState<IValueComissaoModal>();

  useEffect(() => {
    if (id) handleGet({ id, setDataCommission });
  }, [id]);

  useEffect(() => {
    if (!open) setId("");
  }, [open]);

  return (
    <ModalCore
      loading={loading}
      open={open}
      setOpen={setOpen}
      subTitle="Esta é a grade que o escritório recebe"
      sxStyle={{ width: "600px" }}
      title="Comissões da corretora"
    >
      {dataCommission && (
        <ModalCommissionProgress dataCommission={dataCommission} />
      )}
    </ModalCore>
  );
};
